module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-green-1dbb9a.svg";